import React from 'react';
import type { NavigationProp } from '@react-navigation/native';
import { useNavigation } from '@react-navigation/native';

import { useNavigateToMainTabs } from '../../navigation';
import type { AppStackParamList } from '../../navigation/AppNavigation.props';

export const useOrderStatusNavigation = () => {
  const navigation = useNavigation<NavigationProp<AppStackParamList>>();
  const navigateToMainTabs = useNavigateToMainTabs();
  const handleSelectRewards = React.useCallback(() => {
    void navigateToMainTabs('LoyaltyTab', { screen: 'Challenges' });
  }, [navigateToMainTabs]);
  const handleOrderStatus = React.useCallback(
    (orderId: string) => {
      navigation.navigate('Modal', {
        screen: 'OrderStatus',
        params: { orderId },
      });
    },
    [navigation],
  );
  const handleOnRateOrder = React.useCallback(
    (orderId: string) => {
      navigation.navigate('Modal', {
        screen: 'RateOrder',
        params: { orderId },
      });
    },
    [navigation],
  );

  return {
    handleSelectRewards,
    handleOrderStatus,
    handleOnRateOrder,
  };
};
